if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('#AgreeToTos');

      if (this.checkbox) {
        this.#toggleCheckoutButton();

        this.checkbox.addEventListener('change', () => {
          this.#toggleCheckoutButton();
        });
      }
    }

    #toggleCheckoutButton() {
      document.querySelectorAll('#CheckOut').forEach(button => {
        const disabled = !this.checkbox.checked || button.hasAttribute('data-ll-checkout-locked');
        if (button.disabled !== disabled) button.disabled = disabled;
      });
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}